module.exports = __webpack_public_path__ + "img/01.2b80b716.jpg";